export default __webpack_public_path__ + "static/media/logo-comillas-blanco.3b359640.png";